// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { type Breakpoint, type SxProps, styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import type { Theme } from '../../../theme/Theme';
import Column from './Column';

const StyledDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  '& > div:not([style*="display: none"]):last-of-type > div': {
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      paddingRight: theme.spacing(2),
    },
  },
  containerType: 'inline-size',
  containerName: 'table',
}));

export interface ColumnType {
  readonly name: string;
  readonly smallName?: string;
  readonly className?: string;
  readonly values: Array<string | number | React.ReactElement>;
  readonly numeric?: boolean;
  readonly visibleAt?: Breakpoint;
  readonly minWidth?: boolean;
  readonly flex?: string;
  readonly wrapOverFlow?: boolean;
  readonly typographyStyle?: SxProps<Theme>;
  readonly cellStyle?: SxProps<Theme>;
}

interface Props {
  columns: Array<ColumnType>;
  getRowHeight?: (idx: number) => number | null | undefined;
}
function Table({ columns, getRowHeight }: Props): React.ReactElement {
  return (
    <StyledDiv>
      {columns.map((col, idx) => (
        <Column
          key={col.name}
          name={col.name}
          smallName={col.smallName}
          values={col.values}
          numeric={col.numeric}
          visibleAt={col.visibleAt}
          firstCol={idx === 0}
          minWidth={col.minWidth}
          getRowHeight={getRowHeight}
          flex={col.flex}
          wrapOverFlow={col.wrapOverFlow}
          typographyStyle={col.typographyStyle}
          cellStyle={col.cellStyle}
        />
      ))}
    </StyledDiv>
  );
}

export default Table;
